<div class="container">
  <div class="row">
    <div class="col-auto pl-1 m-0" *ngIf="!isValid">
      <div style="width: 5px; height: 90%;" class="eca-invalid-bg"></div>
    </div>
    <div class="col m-0 p-0">

      <div class="form-group">
        <label [for]="controlId"><strong>{{label}}</strong></label>
        <div *ngIf="!isValid && validationMessage" class="eca-invalid"><strong>{{validationMessage}}</strong></div>
        <div class="input-group eca-flex-nowrap">
          <p-calendar [id]="controlId"
                      #ecaDatePicker
                      [(ngModel)]="selectedDate"
                      [ngClass]="isDisabled ? 'eca-disabled' : 'eca-enabled' + (isValid ? '': ' eca-invalid-input')"
                      [disabled]="isDisabled"
                      (ngModelChange)="selectedDateChanged()"
                      [dateFormat]="dateFormat"
                      [placeholder]="isDisabled ? '' : placeholder"
                      [minDate]="minDate"
                      [maxDate]="maxDate"
                      [showButtonBar]="true"
                      appendTo="body"
                      *ngIf="!isDisabled || selectedDate">
          </p-calendar>
          <input type="text"  class="form-control" readonly *ngIf="isDisabled && !selectedDate">
          <ng-template #popTemplate>
            <div *ngIf="!!popoverText" [ngClass]="isRequired ? 'required-input-guide' : 'optional-input-guide'"
                 [innerHtml]="popoverText"></div>
          </ng-template>
          <div class="input-group-append" *ngIf="popoverText">
            <app-eca-input-guide [popoverText]="popoverText" [isRequired]="isRequired"
                                 [isDisabled]="isDisabled"></app-eca-input-guide>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
